export enum SignatoryTypeForm {
  Insert = 1,
  Edit = 2
}
